import { render, staticRenderFns } from "./Compania.vue?vue&type=template&id=5b21fed0"
import script from "./Compania.vue?vue&type=script&lang=js"
export * from "./Compania.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports